import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

import api from '@/services/api';

import { authActions } from '@/store/actions/auth.actions';

import { checkInitialParams } from "@/utils/functions/checkInitialParams";

import btu_logo from '@/assets/images/logo.svg';

const MimSuccess = () => {
	const { hash: locationHash, search } = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (search) {
			const searchParams = new URLSearchParams(search);
			const oidcSessionId = searchParams.get('OidcSessionId');
			if (oidcSessionId) {
				sessionStorage.setItem('oidcSessionId', oidcSessionId);
			}
		}
		if (locationHash) {
			api.put(`/oauth/token`, {
				token: locationHash.replace('#', ''),
			},
			)
				.then((response) => {
					dispatch(authActions.signIn({ token: response.headers.authorization }));
					dispatch(authActions.setUser(response.data));
					const initialParams = checkInitialParams(null, '', response.data);
					navigate(`/letters?${initialParams}`, { replace: true });
				});
		}
	}, [ locationHash, dispatch ]);

	return (
		<main className='error__main'>
			<div className='error__container'>
				<img
					src={ btu_logo }
					alt='logo btu'
					className='error__logo'
				/>
				<p><strong>Nastąpiło pomyślne zalogowanie</strong></p>
				<p>Za chwilę zostaniesz przeniesiony na stronę pism.</p>
			</div>
		</main>
	);
};
export default MimSuccess;
